



























































import { Component, Prop, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Types
import { IBasketProviderData } from "@/models/providers/baskets";
import { IBasketRoute } from "@/models/baskets";
import { QUERY_PARAMS } from "@/data/constants";
import hash from "object-hash";
import _ from "@/boot/lodash";

@Component({
  components: {
    "client-footer": () => import("@/skeleton/client/clientFooter.vue"),
    "basket-topper": () =>
      import("@/components/app/global/baskets/basket/basketTopper.vue"),
    "basket-notifications": () =>
      import("@/components/app/global/baskets/basket/basketNotifications.vue"),
    "basket-stepper": () =>
      import("@/components/app/global/baskets/basket/basketStepper.vue"),
    "basket-button": () =>
      import("@/components/app/global/baskets/basket/basketButton.vue"),
    "basket-currency-switcher": () =>
      import(
        "@/components/app/global/baskets/basket/basketCurrencySwitcher.vue"
      )
  }
})
export default class BasketSteppedView extends Mixins(Context) {
  // Inject

  @Inject({ from: "basketProviderData" })
  public $basketData!: () => IBasketProviderData;

  public get basketData() {
    return this.$basketData();
  }

  // Props

  @Prop({ required: true })
  public basketRoutes!: IBasketRoute[];

  // Computed

  /**
   * @desc This key is required to help prevent caching issues when routing
   * directly between two different eg 'productViews'. Without some uniqueness
   * around the basket product id/product id, provision field values etc can be
   * incorrectly associated with the wrong product.
   */

  public get routerViewKey() {
    return hash({
      currency: this.basketData.currencyCode,
      ..._.pick(this.$route.query, [
        QUERY_PARAMS.BASKET_PRODUCT_ID,
        QUERY_PARAMS.PRODUCT_ID
      ])
    });
  }
}
